import { zodResolver } from '@hookform/resolvers/zod'
import { Button, Input } from 'antd'
import { Controller, useForm } from 'react-hook-form'

import {
  BRAND_ALIAS_MAX_LENGTH,
  brandAliasFormSchema,
  type BrandAliasFormValues,
} from '../BrandAliasesModal.config'
import cn from '../BrandAliasesModal.module.scss'

interface AddBrandAliasFormProps {
  isPending: boolean
  onAdd: (alias: string, onAdded: () => void) => void
}

function AddBrandAliasForm({ isPending, onAdd }: AddBrandAliasFormProps) {
  const { control, handleSubmit, reset } = useForm<BrandAliasFormValues>({
    resolver: zodResolver(brandAliasFormSchema),
    defaultValues: { alias: '' },
    mode: 'onSubmit',
  })

  const handleAdd = handleSubmit((values) => {
    if (isPending) return
    onAdd(values.alias, () => reset({ alias: '' }))
  })

  return (
    <form className={cn.addForm} onSubmit={handleAdd}>
      <Controller
        control={control}
        name="alias"
        render={({ field, fieldState }) => (
          <div className={cn.addField}>
            <Input
              {...field}
              aria-label="Добавить синоним"
              placeholder="Добавить синоним"
              maxLength={BRAND_ALIAS_MAX_LENGTH}
              status={fieldState.error ? 'error' : undefined}
            />
            {fieldState.error && (
              <span className={cn.error}>{fieldState.error.message}</span>
            )}
          </div>
        )}
      />
      <Button htmlType="submit" type="primary" loading={isPending}>
        Добавить
      </Button>
    </form>
  )
}

export default AddBrandAliasForm
